import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function CtaSection() {
    return (
        <section className="py-16 md:py-24" data-testid="cta-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-brand-500 to-brand-600 px-8 md:px-16 py-14 md:py-20 text-white shadow-brand">
                    {/* decorative rings */}
                    <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full border-[10px] border-white/10" />
                    <div className="absolute -right-12 -bottom-12 h-52 w-52 rounded-full border-[8px] border-accent-300/40" />
                    <div className="absolute -left-12 -bottom-12 h-40 w-40 rounded-full bg-white/5 blur-2xl" />

                    <div className="relative grid md:grid-cols-12 gap-8 items-center">
                        <div className="md:col-span-8">
                            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/15 backdrop-blur text-[11px] font-semibold tracking-widest uppercase">
                                Begin Today
                            </span>
                            <h2 className="mt-5 text-3xl md:text-5xl font-heading font-semibold tracking-tight leading-tight">
                                Step onto the mat. The rest unfolds.
                            </h2>
                            <p className="mt-5 text-base md:text-lg text-white/85 max-w-2xl leading-relaxed">
                                Enroll in a course or pick up the gear that fits your
                                practice — students get free shipping on all yoga
                                essentials this season.
                            </p>
                        </div>

                        <div className="md:col-span-4 flex flex-col gap-3 md:items-end">
                            <Button
                                asChild
                                className="rounded-full bg-white text-brand-700 hover:bg-white/90 px-7 py-6 text-base shadow-soft group w-full md:w-auto"
                                data-testid="cta-explore-courses"
                            >
                                <a href="#courses">
                                    Explore Courses
                                    <ArrowRight className="ml-1 h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
                                </a>
                            </Button>
                            <Button
                                asChild
                                className="rounded-full bg-accent-500 hover:bg-accent-600 text-white px-7 py-6 text-base shadow-accent w-full md:w-auto"
                                data-testid="cta-shop-now"
                            >
                                <a href="#products">Shop Products</a>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
